import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@material-ui/core/TextField";
import { Calendar } from "primereact/calendar";
// import QRCode from "react-qr-code";
import {
  alertActions,
  CartonReturnActions,
} from "../../actions/CartonReturnActions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import { InputText } from "primereact/inputtext";
import Loader from "../../templates/Loader.js";

class CartonReturn extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
    //   mobileNumber: "",
      sequenceNo:0,
      datalist: [],
       selectedRows: []
         };
  }
  componentDidMount() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toLocaleDateString();
    this.tblResponse.ToDate = new Date().toLocaleDateString();
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    this.props.fetchApi(this.tblResponse);
    // this.props.exportingData(this.tblResponse);
  }
  onReverseClick() {
  const { selectedRows } = this.state;

  if (!selectedRows || selectedRows.length === 0) {
      this.toast.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select at least one row",
          life: 3000,
      });
      return;
  }

  // ✔ Take only the first row because API expects a single object
  const row = selectedRows[0];

  const payload = {
      SeqNo: row.SeqNo,
      FromUserId: row.UserId,
    //   ToUserId: null,
      Points: row.Points
  };

  this.props.SaveReversePoint(payload).then(response => {

      if (response.ResponseCode === "200") {
          this.toast.show({
              severity: "success",
              summary: "Success",
              detail: "Reversed successfully",
              life: 3000,
          });

          this.setState({ selectedRows: [] });
          this.props.fetchApi(this.tblResponse);
      } 
      else {
          this.toast.show({
              severity: "error",
              summary: "Error",
              detail: response.ResponseMessage,
              life: 3000,
          });
      }
  });
}
  
  componentDidUpdate(prevProps) {
    if (prevProps.DemappingRptList !== this.props.DemappingRptList) {
      // this.props.myProp has a different value
      if (this.props.DemappingRptList) {
        var e = this.props.DemappingRptList;
        
      }
    }
  }

  GetDemapping() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);

    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);

    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
    // this.props.exportingData(this.tblResponse);
  }

  
 FilterData() {
  const body = {
    sequenceNo: this.state.sequenceNo,
    //mobileNumber: this.state.mobileNumber,
   // fromDate: this.state.FromDate.toLocaleDateString(),
    //toDate: this.state.ToDate.toLocaleDateString()
  };

  
  this.props.fetchApi(body);
}


  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();

    dt = yyyy + "/" + mm + "/" + dd;
    return dt;
  }

  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          // this.refs.Messchild.showError("Please select from date.");
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select from date.",
            life: 3000,
          });

          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          // this.refs.Messchild.showError("Please enter only date.");
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "From date must be less than to date.",
              life: 3000,
            });
            // this.refs.Messchild.showError("From date must be less than to date.");
            return;
          }
        }
  
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select to date.",
            life: 3000,
          });
          // this.refs.Messchild.showError("Please select to date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          // this.refs.Messchild.showError("Please enter only date.");
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "To date must be greater than from date.",
              life: 3000,
            });
            // this.refs.Messchild.showError("To date must be greater than from date.");
            return;
          }
        }

        break;
      default:
        break;
    }
  
    this.setState({ [name]: value });
  }
  //to lazy load
  // getLazyLoadingValues(event) {
  //   this.setState({ rows: event.rows, first: event.first });
  //   this.tblResponse.PageSize = event.rows;
  //   this.tblResponse.First = event.first + 1;
  //   this.tblResponse.IsActive = true;
  //   this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
  //   //this.tblResponse.SortColumn = event.sortField;
  //   this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  //   this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
  //   this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
  // }

  onPage(event) {
    this.props.loadingData(true);

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    //   this.props.exportingData(this.tblResponse);
    }, 250);
  }

  //to search
  searchFilter(e) {
    // this.props.loadingData(true);
    // this.tblResponse.SearchValue = e.target.value;
    // this.props.fetchApi(this.tblResponse);
    // this.setState({ mobileNumber: e.target.value });
    this.setState({sequenceNo : e.target.value});
 }
  
  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
    // this.props.exportingData(this.tblResponse);
  }

  render() {
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <Loader loader={this.props.loading} />
        <div className="row mb-3">
          <div className="col-md-3">
            <h4>Reverse Point</h4>
          </div>
          <div className="col-md-9">
            <div className="row text-right align-items-center">
              <div className="col-md-6 text-right">
                <span className="p-input-icon-left mr-2">
                  <i className="pi pi-search" />
                  <InputText
                    type="search"
                    onInput={(e) => this.searchFilter(e)}
                    placeholder="Enter Sequence No"
                  />
                </span>
              </div>
              <div className="col-md-6 text-center">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 ml-3 buttone"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
         <DataTable
          value={this.props.DemappingRptList}
          scrollable
          responsive
          selection={this.state.selectedRows}
          //onSelectionChange={(e) => this.setState({ selectedRows: e.value })}
          onSelectionChange={(e) => {}}
          selectionMode={null} 
         >
         <Column
            headerStyle={{ width: "3rem" }}
            body={(rowData) => {
            const isSelected = this.state.selectedRows.some(x => x.SeqNo === rowData.SeqNo);

           return (
              <input
               type="checkbox"
               checked={isSelected}
               onChange={(e) => {
                if (e.target.checked) {
                this.setState({ selectedRows: [rowData] });     
               } else {
               this.setState({ selectedRows: [] });            
              }
             }}
            />
         );
        }}
      />  
  <Column field="SeqNo" header="Sr No" />
  {/* <Column field="UserId" header="User Id" /> */}
  <Column field="UserName" header="User Name" />
  <Column field="Points" header="Points" />
  <Column
  header="QR Code"
  body={(rowData) => {
    const canvasId = `canvas_${rowData.SeqNo}`;
    // Generate QR using QRious
    setTimeout(() => {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return;

      const qr = new QRious({
        element: canvas,
        value:`https://astraverniciitalia.com/pa?uid=${rowData.QrData}`,
        //  value: `http://104.211.167.63:5046/pa?uid=${rowData.QrData}`,
        size: 70,
      });
    }, 0);  
  
    // const qr2= new QRius({
    //   element :canvas,
    //   value :`https://104.211.167.63:5046/pa?uid=${rowData.QrCode}`
    // });
    // },0);
    const downloadQR = () => {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return;
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `QR_${rowData.SeqNo}.png`;
      link.click();
    };    
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <canvas id={canvasId}></canvas>
        <button onClick={downloadQR} className="btn btn-link btn-sm">
          Download QR
        </button>
      </div>
    );
  }}
/>

</DataTable>
{this.props.DemappingRptList && this.props.DemappingRptList.length > 0 && (
    <div className="text-right mt-3">
      <button 
          className="btn btn-danger"
          disabled={this.state.selectedRows.length === 0}
          onClick={() => this.onReverseClick()}          
      >
          Reverse
      </button>
    </div>
  )}
        </div>
      </div>
    );
  }
}   

const mapStateToProps = (state) => {
  return {
    DemappingRptList: state.Reverse.items,
    List:
      state.DemappingRpt.exportitems == undefined
        ? []
        : state.DemappingRpt.exportitems,
    loading: state.verification.loading,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(CartonReturnActions.getAll(obj));
      
    },
    SaveReversePoint: (obj) => dispatch(CartonReturnActions.SaveReversePoint(obj)),
    // loadingData: (isLoding) =>
    //   dispatch(CartonReturnActions.loadingData(isLoding)),
    // exportingData: (obj) => dispatch(CartonReturnActions.exportData(obj)),
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(CartonReturn);